'use client';

import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,  } from 'recharts';

const data = [
  { day: 'Mar 17', success: 198, failed: 12, rolledBack: 3 },
  { day: 'Mar 18', success: 224, failed: 8, rolledBack: 1 },
  { day: 'Mar 19', success: 187, failed: 19, rolledBack: 7 },
  { day: 'Mar 20', success: 251, failed: 6, rolledBack: 2 },
  { day: 'Mar 21', success: 213, failed: 11, rolledBack: 4 },
  { day: 'Mar 22', success: 239, failed: 14, rolledBack: 2 },
  { day: 'Mar 23', success: 174, failed: 29, rolledBack: 8 },
];

const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    const total = payload.reduce((s: number, p: any) => s + p.value, 0);
    return (
      <div className="bg-surface-overlay border border-border rounded-lg px-3 py-2.5 shadow-xl text-xs space-y-1">
        <p className="text-muted font-mono mb-1">{label}</p>
        {payload.map((p: any) => (
          <div key={`tip-exec-${p.dataKey}`} className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-sm flex-shrink-0" style={{ background: p.fill }} />
            <span className="text-foreground-muted capitalize">{p.dataKey}:</span>
            <span className="font-semibold text-foreground font-mono">{p.value}</span>
          </div>
        ))}
        <div className="border-t border-border pt-1 flex justify-between">
          <span className="text-muted">Total:</span>
          <span className="font-mono font-bold text-foreground">{total}</span>
        </div>
      </div>
    );
  }
  return null;
};

export default function ExecutionVolumeChart() {
  return (
    <div className="bg-surface border border-border rounded-xl p-5 h-full">
      <div className="flex items-center justify-between mb-4">
        <div>
          <p className="text-sm font-semibold text-foreground">Remediation Job Executions</p>
          <p className="text-[11px] text-muted mt-0.5">Last 7 days · All automation rules</p>
        </div>
        <div className="flex items-center gap-3 text-[11px]">
          <div className="flex items-center gap-1.5">
            <span className="w-2.5 h-2.5 rounded-sm bg-success" />
            <span className="text-muted">Success</span>
          </div>
          <div className="flex items-center gap-1.5">
            <span className="w-2.5 h-2.5 rounded-sm bg-danger" />
            <span className="text-muted">Failed</span>
          </div>
          <div className="flex items-center gap-1.5">
            <span className="w-2.5 h-2.5 rounded-sm bg-warning" />
            <span className="text-muted">Rolled Back</span>
          </div>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={data} margin={{ top: 4, right: 4, left: -20, bottom: 0 }} barSize={18}>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(222 14% 20%)" vertical={false} />
          <XAxis dataKey="day" tick={{ fontSize: 10, fill: 'hsl(222 10% 45%)' }} axisLine={false} tickLine={false} />
          <YAxis tick={{ fontSize: 10, fill: 'hsl(222 10% 45%)' }} axisLine={false} tickLine={false} />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: 'hsl(222 14% 20% / 0.5)' }} />
          <Bar dataKey="success" stackId="a" fill="hsl(142 71% 45%)" radius={[0, 0, 0, 0]} />
          <Bar dataKey="failed" stackId="a" fill="hsl(0 84% 60%)" radius={[0, 0, 0, 0]} />
          <Bar dataKey="rolledBack" stackId="a" fill="hsl(38 92% 50%)" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}